const dateObjectFromDateString = (dateString: string) => {
  const dateOfBirth = dateString.split('-');
  return {
    year: Number(dateOfBirth[0]),
    month: Number(dateOfBirth[1]),
    day: Number(dateOfBirth[2]),
  };
};

export default dateObjectFromDateString;
